import moment from 'moment'
import Column from './Column'

export default class DateColumn extends Column {
  render = row => moment(row[this.field]).format('DD/MM/YYYY')
}
